function onClickOutside($elements, callback) {
  if (!Array.isArray($elements)) {
    $elements = [$elements];
  }

  const $elementsAndchildren = [];
  $elements.forEach(($element) => {
    $elementsAndchildren.push($element);
    $elementsAndchildren.push(...$element.querySelectorAll('*'));
  });

  document.addEventListener('click', (e) => {
    if (!$elementsAndchildren.includes(e.target)) {
      callback();
    }
  });
}

export { onClickOutside };
